var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('BannerCompras'),_c('ComprasSubBanner'),_c('ComprasControl'),_c('ComprasVentajas'),_c('AllYouNeed'),_c('CTAInv')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }